(function () {
  function readCtx() {
    try {
      var key = window.pctCartEditMode ? 'pct_cart_ctx' : 'pct_view_ctx';
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      console.warn('Could not parse cart context:', err);
      return null;
    }
  }

  function hidden(name, id, value) {
    var form = document.getElementById('book-builder-form');
    if (!form) return null;
    var input = id ? document.getElementById(id) : null;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      if (id) input.id = id;
      form.appendChild(input);
    }
    input.name = name;
    if (value !== undefined) input.value = value || '';
    return input;
  }

  function setHiddenFromContext(ctx) {
    hidden('properties[_Builder Handle]', 'prop-builder-handle', ctx.builderHandle);
    hidden('properties[_Line Fingerprint]', 'prop-line-fingerprint', ctx.lineFingerprint);
    hidden('properties[_Blueprint Version]', 'prop-blueprint-version', ctx.blueprintVersion);
    hidden('properties[_Blueprint Path]', 'prop-blueprint-path', ctx.blueprintPath);
    hidden('properties[_Photo Manifest Path]', 'prop-photo-manifest-path', ctx.photoManifestPath);
    hidden('properties[_Photo Manifest URL]', 'prop-photo-manifest-url', ctx.photoManifestPath);
    hidden('properties[_Line Signature]', 'prop-line-signature', ctx.lineSignature);
    hidden('properties[_Line Created At]', 'prop-line-created-at', ctx.lineCreatedAt);
  }

  function setCartEditLoading(show, message) {
    var existing = document.getElementById('pct-cart-edit-loading');
    if (!show) {
      if (existing) existing.remove();
      document.body.classList.remove('pct-cart-edit-loading-active');
      return;
    }
    document.body.classList.add('pct-cart-edit-loading-active');
    if (!existing) {
      existing = document.createElement('div');
      existing.id = 'pct-cart-edit-loading';
      existing.style.cssText = 'position:fixed;inset:0;z-index:10000030;background:rgba(255,255,255,0.96);display:flex;align-items:center;justify-content:center;font-family:inherit;';
      existing.innerHTML = '<div style="width:min(420px,calc(100vw - 40px));background:#fff;border:1px solid rgba(0,0,0,0.08);border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,0.16);padding:28px;text-align:center;"><div style="width:34px;height:34px;margin:0 auto 16px;border:3px solid #e8e8e8;border-top-color:#2C3E35;border-radius:50%;animation:pctCartSpin .75s linear infinite;"></div><h2 style="margin:0 0 8px;font-size:22px;color:#111;">Loading your saved book</h2><p data-pct-cart-edit-loading-text style="margin:0;color:#555;font-size:14px;line-height:1.45;">Opening your editable design.</p></div>';
      if (!document.getElementById('pct-cart-edit-loading-style')) {
        var style = document.createElement('style');
        style.id = 'pct-cart-edit-loading-style';
        style.textContent = '@keyframes pctCartSpin{to{transform:rotate(360deg)}}';
        document.head.appendChild(style);
      }
      document.body.appendChild(existing);
    }
    var text = existing.querySelector('[data-pct-cart-edit-loading-text]');
    if (text) text.textContent = message || 'Opening your editable design.';
  }

  function shell(mode) {
    var app = document.querySelector('.pictorel-app-container');
    var sidebar = document.querySelector('.app-sidebar');
    var workspace = document.querySelector('.app-workspace');
    var actionButtons = document.getElementById('design-action-buttons');
    if (app) app.classList.add(mode === 'edit' ? 'pct-cart-edit-mode' : 'pct-cart-view-mode');
    if (mode === 'edit') setCartEditLoading(true);
    if (mode === 'view') {
      if (sidebar) sidebar.style.display = 'none';
      if (workspace) workspace.style.flexDirection = 'column';
      if (actionButtons) actionButtons.style.display = 'none';
    }

    var bar = document.getElementById('pct-cart-view-bar');
    if (bar) return;
    bar = document.createElement('div');
    bar.id = 'pct-cart-view-bar';
    bar.style.cssText = 'position:fixed;right:24px;top:82px;z-index:10000000;display:flex;align-items:center;gap:12px;padding:10px 12px 10px 18px;border-radius:999px;background:rgba(255,255,255,0.94);box-shadow:0 14px 40px rgba(0,0,0,0.14);border:1px solid rgba(0,0,0,0.08);font-family:inherit;';
    bar.innerHTML = '<span style="font-size:13px;font-weight:700;color:#2C3E35;white-space:nowrap;">' + (mode === 'edit' ? 'Editing from cart' : 'Preview from cart') + '</span><button type="button" style="border:none;border-radius:999px;background:#2C3E35;color:#fff;font-size:13px;font-weight:800;padding:10px 16px;cursor:pointer;">Back to cart</button>';
    bar.querySelector('button').addEventListener('click', function () { window.location.href = '/cart'; });
    document.body.appendChild(bar);
  }

  function installBuilderFallbackHooks() {
    if (!window.pctRenderUploadedGallery) {
      window.pctRenderUploadedGallery = function () {
        var gallery = document.getElementById('uploaded-gallery');
        var dsGallery = document.getElementById('ds-gallery');
        if (gallery) gallery.innerHTML = '';
        if (dsGallery) dsGallery.innerHTML = '';
        (window.uploadedImagesData || []).forEach(function (photo) {
          var src = photo.thumb || photo.highres || '';
          if (!src) return;
          if (gallery) {
            var img = document.createElement('img');
            img.src = src;
            img.className = 'gallery-thumbnail';
            img.loading = 'lazy';
            img.decoding = 'async';
            img.setAttribute('data-highres', photo.highres || src);
            img.setAttribute('data-photo-id', photo.photoId || '');
            img.onclick = function () {
              if (window.openGridManager) window.openGridManager();
              if (window.openPreviewModal) window.openPreviewModal(photo.highres || src, img, photo.photoId);
            };
            gallery.appendChild(img);
          }
          if (dsGallery) {
            var modalImg = document.createElement('img');
            modalImg.src = src;
            modalImg.loading = 'lazy';
            modalImg.decoding = 'async';
            modalImg.setAttribute('data-highres', photo.highres || src);
            modalImg.setAttribute('data-photo-id', photo.photoId || '');
            modalImg.onclick = function () {
              if (window.addImageToFabric) window.addImageToFabric(photo.highres || src, src);
            };
            dsGallery.appendChild(modalImg);
          }
        });
      };
    }
    if (!window.pctSelectTierForPhotoCount) {
      window.pctSelectTierForPhotoCount = function (count) {
        if (isIntentionalEditionGap(count)) {
          if (window.showToast) window.showToast('You have 101 or 201 photos. Please remove one photo or upload one more to continue.', 5000, 'error');
          keepEditCtaText();
          return;
        }
        var tier = count <= 100 ? 50 : (count <= 200 ? 100 : 200);
        var card = document.querySelector('.tier-card[data-tier="' + tier + '"]');
        if (card && !card.classList.contains('selected')) card.click();
        keepEditCtaText();
      };
    }
  }

  function api(path, body) {
    return fetch('/apps/pictoirel/' + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(async function (response) {
      var text = await response.text();
      var payload = null;
      try { payload = text ? JSON.parse(text) : null; } catch (err) {}
      if (!response.ok) throw new Error((payload && payload.message) || text || 'Request failed.');
      return payload || {};
    });
  }

  function lineFields(ctx) {
    return {
      book_id: ctx.bookId,
      storage_folder: ctx.storageFolder,
      blueprint_path: ctx.blueprintPath,
      photo_manifest_path: ctx.photoManifestPath,
      line_fingerprint: ctx.lineFingerprint,
      blueprint_version: ctx.blueprintVersion,
      variant_id: ctx.variantId,
      builder_handle: ctx.builderHandle,
      created_at: ctx.lineCreatedAt
    };
  }

  async function fetchBlueprint(ctx) {
    var url = '/apps/pictoirel/blueprint?book_id=' + encodeURIComponent(ctx.bookId) +
      '&storage_folder=' + encodeURIComponent(ctx.storageFolder) +
      '&view_token=' + encodeURIComponent(ctx.viewToken);
    var response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Blueprint request failed.');
    var memory = await response.json();
    if (!Array.isArray(memory) || !memory.length) throw new Error('Blueprint is empty.');
    return memory;
  }

  async function fetchManifest(ctx) {
    if (!ctx.photoManifestPath || !window.firebaseGetDownloadURL || !window.firebaseRef || !window.firebaseStorage) return null;
    var url = await window.firebaseGetDownloadURL(window.firebaseRef(window.firebaseStorage, ctx.photoManifestPath));
    var response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('Photo manifest request failed.');
    return response.json();
  }

  function photoCount() {
    return (window.uploadedImagesData || []).filter(function (photo) {
      return photo && photo.status !== 'failed' && (photo.highres || photo.originalUrl);
    }).length;
  }

  function isIntentionalEditionGap(count) {
    return Number(count) === 101 || Number(count) === 201;
  }

  function keepEditCtaText() {
    var text = document.getElementById('checkout-btn-text');
    if (window.pctCartEditMode && text) text.innerHTML = 'Save Changes';
  }

  function hydrateCartEditControls(ctx) {
    if (!ctx) return;
    window.pctCartEditHydrating = true;
    try {
      function text(id, value) {
        var el = document.getElementById(id);
        if (el && value) el.textContent = value;
      }
      function value(id, val) {
        var el = document.getElementById(id);
        if (el && val != null) el.value = val;
      }
      function findValueItem(listId, val, year) {
        var list = document.getElementById(listId);
        if (!list || !val) return null;
        return Array.from(list.querySelectorAll('.dropdown-item')).find(function (item) {
          var data = item.getAttribute('data-value') || '';
          return data === val || (year && data.replace('[Year]', year) === val);
        });
      }
      function selectItem(item) {
        if (!item) return;
        var list = item.parentElement;
        if (list) list.querySelectorAll('.dropdown-item').forEach(function (el) { el.classList.remove('selected'); });
        item.classList.add('selected');
      }
      function clickValue(listId, val) {
        var item = findValueItem(listId, val, ctx.year);
        if (item) item.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
      function inferOccasion() {
        var key = String(ctx.stickerAsset || ctx.title || '').toLowerCase();
        if (key.indexOf('graduation') >= 0 || /class|congratulations|future|beginnings/.test(key)) return 'Graduation';
        if (key.indexOf('newyear') >= 0 || key.indexOf('new year') >= 0) return 'New Year';
        return key ? 'Birthday' : '';
      }
      function inferFestival() {
        var key = String(ctx.stickerAsset || ctx.title || '').toLowerCase();
        var map = [['christmas', 'Christmas'], ['diwali', 'Diwali'], ['eid', 'Eid'], ['halloween', 'Halloween'], ['holi', 'Holi'], ['chinesenewyear', 'Chinese New Year'], ['autumn', 'Autumn'], ['spring', 'Spring']];
        for (var i = 0; i < map.length; i++) if (key.indexOf(map[i][0]) >= 0) return map[i][1];
        return '';
      }
      if (ctx.year) {
        text('year-dropdown-text', ctx.year);
        value('prop-year', ctx.year);
        text('live-year-preview', ctx.year);
        selectItem(findValueItem('year-dropdown-list', ctx.year));
      }
      var occasion = inferOccasion();
      var festival = inferFestival();
      if (occasion && document.getElementById('occasion-dropdown-list')) {
        clickValue('occasion-dropdown-list', occasion);
        text('occasion-dropdown-text', occasion);
      }
      if (festival && document.getElementById('festival-dropdown-list')) {
        clickValue('festival-dropdown-list', festival);
        text('festival-dropdown-text', festival);
      }
      ['title-list', 'occasion-title-list', 'festival-title-list'].forEach(function (listId) {
        var item = findValueItem(listId, ctx.title, ctx.year);
        if (item) selectItem(item);
      });
      text('title-dropdown-text', ctx.title);
      text('occasion-title-text', ctx.title);
      text('festival-title-text', ctx.title);
      value('prop-title', ctx.title);
      var titleInner = document.getElementById('live-title-inner');
      if (titleInner && ctx.title) titleInner.textContent = ctx.title;
      if (ctx.coverHex || ctx.cover) {
        var swatches = Array.from(document.querySelectorAll('.color-swatch[data-color]'));
        var match = swatches.find(function (sw) {
          return (ctx.coverHex && sw.getAttribute('data-color').toLowerCase() === String(ctx.coverHex).toLowerCase()) || sw.getAttribute('data-name') === ctx.cover;
        });
        if (match) {
          swatches.forEach(function (sw) { sw.classList.remove('selected'); });
          match.classList.add('selected');
        }
        value('prop-cover', ctx.cover);
        value('prop-cover-hex', ctx.coverHex);
        var layer = document.getElementById('book-color-layer');
        if (layer && ctx.coverHex) layer.style.backgroundColor = ctx.coverHex;
      }
      if (ctx.stickerAsset || ctx.symbol) {
        var sticker = Array.from(document.querySelectorAll('.symbol-item[data-asset], .dest-symbol-item[data-asset]')).find(function (item) {
          return item.getAttribute('data-asset') === ctx.stickerAsset;
        });
        if (sticker) {
          document.querySelectorAll('.symbol-item, .dest-symbol-item').forEach(function (item) { item.classList.remove('selected'); });
          sticker.classList.add('selected');
          var img = sticker.querySelector('img');
          var live = document.getElementById('live-symbol-preview');
          if (live) live.innerHTML = img ? img.outerHTML : '';
          value('prop-symbol', sticker.getAttribute('data-name') || ctx.symbol);
        } else {
          value('prop-symbol', ctx.symbol);
        }
        value('prop-sticker-asset', ctx.stickerAsset);
      }
    } finally {
      window.pctCartEditHydrating = false;
    }
  }

  function restoreCartEditPhotoManifest(manifest) {
    var photos = manifest && Array.isArray(manifest.photos) ? manifest.photos : [];
    window.uploadedImagesData = photos.map(function (photo, index) {
      var failed = photo && photo.status === 'failed';
      var highresPath = String((photo && photo.highresPath) || '');
      var statusPath = photo.statusPath || highresPath.replace(/\/full\.jpg$/i, '/status.json');
      var rawPath = photo.rawPath || photo.sourcePath || photo.printPath || '';
      return {
        photoId: photo.photoId || ('cart-photo-' + index),
        filename: photo.filename || photo.name || 'photo.jpg',
        name: photo.filename || photo.name || 'photo.jpg',
        thumbPath: photo.thumbPath || '',
        highresPath: photo.highresPath || '',
        rawPath: rawPath,
        sourcePath: photo.sourcePath || rawPath,
        printPath: photo.printPath || rawPath,
        statusPath: statusPath,
        thumb: photo.thumbUrl || photo.thumb || photo.highresUrl || photo.highres || '',
        previewUrl: photo.thumbUrl || photo.thumb || photo.highresUrl || photo.highres || '',
        highres: photo.highresUrl || photo.highres || photo.thumbUrl || photo.thumb || '',
        originalUrl: photo.highresUrl || photo.highres || '',
        width: Number(photo.width || 1),
        height: Number(photo.height || 1),
        orientation: photo.orientation || 'landscape',
        status: failed ? 'failed' : 'ready',
        serverStatus: failed ? 'failed' : 'complete',
        previewStatus: failed ? 'failed' : 'uploaded',
        originalStatus: failed ? 'failed' : 'uploaded',
        failureReason: photo.failureReason || ''
      };
    }).filter(function (photo) {
      return photo.status === 'failed' || photo.highres || photo.thumb;
    });

    if (window.pctRenderUploadedGallery) window.pctRenderUploadedGallery();
    if (window.updateUploadStatus) window.updateUploadStatus();
    return window.uploadedImagesData;
  }

  function readFormProperties(form) {
    var props = {};
    Array.from(new FormData(form).entries()).forEach(function (entry) {
      var match = entry[0].match(/^properties\[(.+)\]$/);
      if (match) props[match[1]] = entry[1];
    });
    return props;
  }

  function findCurrentLine(cart, ctx, variantId) {
    var items = cart && cart.items ? cart.items : [];
    var exact = items.find(function (item) { return item.key === ctx.lineKey; });
    if (exact) return exact;
    var matches = items.filter(function (item) {
      var variantOk = !variantId || String(item.variant_id || '') === String(variantId);
      return variantOk && isMatchingLine(item, ctx);
    });
    return matches.length ? matches[0] : null;
  }

  function isMatchingLine(item, ctx, variantId) {
    var props = item && item.properties ? item.properties : {};
    var variantOk = !variantId || String(item.variant_id || '') === String(variantId || '');
    return !!item && variantOk && props['_Line Fingerprint'] === ctx.lineFingerprint && props['_Book ID'] === ctx.bookId;
  }

  function findNewVariantLine(cart, ctx, nextVariantId) {
    var items = cart && cart.items ? cart.items : [];
    var matches = items.filter(function (item) {
      return isMatchingLine(item, ctx, nextVariantId);
    });
    return matches.length ? matches[0] : null;
  }

  function patchBlueprintPhotoRefs(memory) {
    var urlMap = new Map();
    var entryMap = new Map();
    function previewUrl(value) {
      if (!value || !window.getPreviewUrl) return value || '';
      try { return window.getPreviewUrl(value); } catch (err) { return value; }
    }
    function refsFor(photo) {
      if (!photo) return [];
      return [
        photo.photoId,
        photo.thumb,
        previewUrl(photo.thumb),
        photo.previewUrl,
        photo.highres,
        previewUrl(photo.highres),
        photo.originalUrl,
        photo.rawPath,
        photo.sourcePath,
        photo.printPath,
        photo.statusPath,
        photo.highresPath,
        photo.thumbPath
      ].filter(Boolean);
    }
    function applyPrintMetadata(obj, photo) {
      if (!obj || !photo) return;
      var rawPath = photo.rawPath || photo.sourcePath || photo.printPath || '';
      obj.photoId = photo.photoId || obj.photoId || '';
      if (rawPath) {
        obj.rawPath = rawPath;
        obj.sourcePath = photo.sourcePath || rawPath;
        obj.printPath = photo.printPath || rawPath;
      }
      if (photo.statusPath) obj.statusPath = photo.statusPath;
    }
    (window.uploadedImagesData || []).forEach(function (photo) {
      if (!photo || photo.status === 'failed') return;
      refsFor(photo).forEach(function (ref) {
        entryMap.set(ref, photo);
        if (photo.highres && ref !== photo.highres) urlMap.set(ref, photo.highres);
      });
    });
    (memory || []).forEach(function (spread) {
      (spread.objects || []).forEach(function (obj) {
        if (!obj) return;
        var photo = (obj.photoId && entryMap.get(obj.photoId)) ||
          (obj.customUrl && entryMap.get(obj.customUrl)) ||
          (obj.customThumbSrc && entryMap.get(obj.customThumbSrc));
        applyPrintMetadata(obj, photo);
        if (obj.customUrl && urlMap.has(obj.customUrl)) obj.customUrl = urlMap.get(obj.customUrl);
        if (obj.customThumbSrc && urlMap.has(obj.customThumbSrc)) obj.customThumbSrc = urlMap.get(obj.customThumbSrc);
      });
    });
  }

  function currentSnapshot(form) {
    var props = readFormProperties(form);
    var variantInput = form.querySelector('[name="id"]');
    return {
      title: props['Book Title'] || '',
      year: props['Book Year'] || '',
      cover: props['Cover Color'] || props['Cover Template'] || '',
      destinationCountry: props['Destination Country'] || '',
      coverTemplate: props['Cover Template'] || '',
      edition: props['Edition Capacity'] || '',
      variantId: variantInput ? variantInput.value : '',
      photoCount: photoCount()
    };
  }

  function parsePrice(text) {
    var match = String(text || '').match(/AED\s*([0-9]+)/i);
    return match ? 'AED ' + match[1] : '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
    });
  }

  function showCartEditReviewModal(changes, quantity) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('[data-pct-cart-edit-review]');
      if (existing) existing.remove();
      var overlay = document.createElement('div');
      overlay.setAttribute('data-pct-cart-edit-review', 'true');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:10000020;background:rgba(0,0,0,0.38);display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit;';
      var list = changes.length ? '<ul style="margin:12px 0 0;padding-left:18px;color:#333;line-height:1.55;">' + changes.map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul>' : '<p style="margin:12px 0 0;color:#555;">No changes detected. Return to cart?</p>';
      overlay.innerHTML = '<div role="dialog" aria-modal="true" aria-labelledby="pct-review-title" style="width:min(520px,100%);background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,0.22);padding:24px;">' +
        '<h2 id="pct-review-title" style="margin:0 0 8px;font-size:22px;line-height:1.2;color:#111;">Review changes</h2>' +
        '<p style="margin:0;color:#555;font-size:14px;">This will update the book in your cart.</p>' +
        list +
        '<p style="margin:16px 0 0;color:#2C3E35;font-weight:800;">Quantity affected: ' + Number(quantity || 1) + (Number(quantity || 1) === 1 ? ' copy' : ' copies') + '</p>' +
        '<div style="display:flex;gap:10px;justify-content:flex-end;margin-top:22px;">' +
        '<button type="button" data-pct-review-cancel style="border:1px solid #ddd;background:#fff;border-radius:999px;padding:12px 18px;font-weight:800;cursor:pointer;">Cancel</button>' +
        '<button type="button" data-pct-review-save style="border:0;background:#2C3E35;color:#fff;border-radius:999px;padding:12px 18px;font-weight:900;cursor:pointer;">Save Changes</button>' +
        '</div></div>';
      function close(result) {
        overlay.remove();
        resolve(result);
      }
      overlay.querySelector('[data-pct-review-cancel]').addEventListener('click', function () { close(false); });
      overlay.querySelector('[data-pct-review-save]').addEventListener('click', function () { close(true); });
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) close(false);
      });
      document.body.appendChild(overlay);
    });
  }

  function showCartEditSuccessModal() {
    return new Promise(function (resolve) {
      var overlay = document.createElement('div');
      overlay.setAttribute('data-pct-cart-edit-success', 'true');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:10000025;background:rgba(0,0,0,0.38);display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit;';
      overlay.innerHTML = '<div role="dialog" aria-modal="true" style="width:min(420px,100%);background:#fff;border-radius:18px;box-shadow:0 24px 80px rgba(0,0,0,0.22);padding:26px;text-align:center;">' +
        '<h2 style="margin:0 0 8px;font-size:22px;line-height:1.2;color:#111;">Changes saved successfully.</h2>' +
        '<p style="margin:0;color:#555;font-size:14px;">Opening your cart with the updated book.</p>' +
        '<button type="button" data-pct-success-ok style="margin-top:22px;border:0;background:#2C3E35;color:#fff;border-radius:999px;padding:12px 22px;font-weight:900;cursor:pointer;">View cart</button>' +
        '</div>';
      function close() {
        overlay.remove();
        resolve();
      }
      overlay.querySelector('[data-pct-success-ok]').addEventListener('click', close);
      document.body.appendChild(overlay);
    });
  }

  function pctShowCartEditReview(ctx, snapshot) {
    var original = window.pctOriginalCartEditSnapshot || {};
    var changes = [];
    [['Book title', 'title'], ['Year', 'year'], ['Destination', 'destinationCountry'], ['Cover', 'cover'], ['Template', 'coverTemplate'], ['Edition', 'edition']].forEach(function (row) {
      var from = original[row[1]] || '';
      var to = snapshot[row[1]] || '';
      if (from !== to) changes.push(row[0] + ': ' + (from || 'None') + ' -> ' + (to || 'None'));
    });
    if (Number(original.photoCount || 0) !== Number(snapshot.photoCount || 0)) {
      changes.push('Photos: ' + Number(original.photoCount || 0) + ' -> ' + Number(snapshot.photoCount || 0));
    }
    if (String(original.variantId || '') !== String(snapshot.variantId || '')) {
      changes.push('Price: ' + (parsePrice(original.edition) || 'current') + ' -> ' + (parsePrice(snapshot.edition) || 'current'));
    }
    if (window.designConfirmed) changes.push('Design layout will be saved');
    var quantity = Number(ctx.quantity || original.quantity || 1);
    return showCartEditReviewModal(changes, quantity);
  }

  async function confirmNewVariantLine(ctx, nextVariantId) {
    var cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
    return findNewVariantLine(cart, ctx, nextVariantId);
  }

  async function prepareFreshCartLineIdentity(ctx, nextVariantId, save) {
    return {
      bookId: ctx.bookId,
      storageFolder: ctx.storageFolder,
      builderHandle: ctx.builderHandle || 'relationship',
      lineFingerprint: ctx.lineFingerprint,
      lineSignature: save.line_signature,
      createdAt: ctx.lineCreatedAt
    };
  }

  async function replaceCartLineVariant(ctx, line, nextVariantId, quantity, properties) {
    var add = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: nextVariantId, quantity: quantity, properties: properties })
    });
    if (!add.ok) throw new Error(await add.text());
    var remove = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    });
    if (!remove.ok) throw new Error('The updated book was added, but the old line could not be removed. Please review your cart.');
  }

  function hydrateBuilderForCartEdit(ctx, memory, manifest) {
    installBuilderFallbackHooks();
    window.pctCartEditPhotosChanged = false;
    window.pctCartEditRegenerating = false;
    var preserveInitialEdition = true;
    if (window.pctHydrateBuilderSelections) window.pctHydrateBuilderSelections(ctx);
    else if (window.pctCartViewBridge && window.pctCartViewBridge.afterCartLoad) window.pctCartViewBridge.afterCartLoad(ctx);
    hydrateCartEditControls(ctx);
    restoreCartEditPhotoManifest(manifest);
    if (!preserveInitialEdition && window.pctSelectTierForPhotoCount) window.pctSelectTierForPhotoCount(photoCount());
    window.pctActiveCartEditContext = ctx;
    window.isEditSession = true;
    if (window.pctCartViewBridge && window.pctCartViewBridge.renderEditMemory) {
      window.pctCartViewBridge.renderEditMemory(memory);
    } else if (window.pctCartViewBridge && window.pctCartViewBridge.renderMemory) {
      window.pctCartViewBridge.renderMemory(memory);
    }
    keepEditCtaText();
    window.pctOriginalCartEditSnapshot = {
      title: ctx.title || '',
      year: ctx.year || '',
      cover: ctx.cover || ctx.coverTemplate || '',
      destinationCountry: ctx.destinationCountry || '',
      coverTemplate: ctx.coverTemplate || '',
      edition: ctx.edition || '',
      variantId: String(ctx.variantId || ''),
      photoCount: photoCount(),
      blueprintVersion: ctx.blueprintVersion,
      quantity: Number(ctx.quantity || 1)
    };
  }

  function installEditUploadStatusHook() {
    if (!window.pctCartEditMode || !window.updateUploadStatus || window.updateUploadStatus.__pctEditWrapped) return;
    var original = window.updateUploadStatus;
    var selecting = false;
    window.updateUploadStatus = function () {
      var result = original.apply(this, arguments);
      if (!window.pctCartEditPhotosChanged) {
        keepEditCtaText();
        return result;
      }
      if (window.pctCartEditRegenerating) {
        keepEditCtaText();
        return result;
      }
      if (!selecting && window.pctSelectTierForPhotoCount) {
        var before = document.querySelector('.tier-card.selected');
        selecting = true;
        window.pctSelectTierForPhotoCount(photoCount());
        selecting = false;
        var after = document.querySelector('.tier-card.selected');
        if (before !== after && original) original.apply(this, arguments);
      }
      keepEditCtaText();
      var saveBtn = document.getElementById('btn-add-cart');
      if (saveBtn) saveBtn.disabled = true;
      requestCartEditLocalRegenerate();
      return result;
    };
    window.updateUploadStatus.__pctEditWrapped = true;
  }

  function installEditDeletionHook() {
    if (!window.pctCartEditMode || !window.executeCoreDeletion || window.executeCoreDeletion.__pctEditWrapped) return;
    var originalDelete = window.executeCoreDeletion;
    window.executeCoreDeletion = function () {
      window.pctCartEditPhotosChanged = true;
      return originalDelete.apply(this, arguments);
    };
    window.executeCoreDeletion.__pctEditWrapped = true;
  }

  function requestCartEditLocalRegenerate() {
    if (!window.pctCartEditMode || !window.pctCartEditPhotosChanged || window.pctCartEditRegenerating || isIntentionalEditionGap(photoCount())) return;
    window.clearTimeout(window.pctCartEditRegenTimer);
    window.pctCartEditRegenTimer = window.setTimeout(function () {
      if (window.pctCartEditRegenerating || window.isAutoPreparingDesign || !window.autoPrepareDesignPreview) return;
      window.pctCartEditRegenerating = true;
      var previousMemory = window.spreadMemory ? JSON.parse(JSON.stringify(window.spreadMemory)) : null;
      var previousConfirmedMemory = window.confirmedSpreadMemory ? JSON.parse(JSON.stringify(window.confirmedSpreadMemory)) : previousMemory;
      function restorePreviousMemory() {
        if (!previousMemory || !previousMemory.length) return;
        window.spreadMemory = JSON.parse(JSON.stringify(previousMemory));
        window.confirmedSpreadMemory = JSON.parse(JSON.stringify(previousConfirmedMemory || previousMemory));
        window.designConfirmed = true;
        window.hasAutoFilled = true;
        if (window.build3DFlipbook) window.build3DFlipbook();
        if (window.updateUploadStatus) window.updateUploadStatus();
        if (window.validateMainStep) window.validateMainStep();
      }
      function finishRegenerate() {
        window.pctCartEditRegenerating = false;
        keepEditCtaText();
        if (window.validateMainStep) window.validateMainStep();
      }
      if (window.designConfirmed || window.hasAutoFilled) {
        window.designConfirmed = false;
        window.hasAutoFilled = false;
      }
      var prepare = window.autoPrepareDesignPreview();
      if (prepare && prepare.then) prepare.then(function () {
        if (window.designConfirmed) window.pctCartEditPhotosChanged = false;
        else restorePreviousMemory();
        finishRegenerate();
      }, function () {
        restorePreviousMemory();
        finishRegenerate();
      });
      else finishRegenerate();
    }, 1200);
  }

  function makeSaveAttemptId() {
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint8Array(12);
      window.crypto.getRandomValues(bytes);
      return 'attempt_' + Array.prototype.map.call(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    }
    return 'attempt_' + String(Date.now()) + '_' + Math.random().toString(36).slice(2, 12);
  }

  document.addEventListener('change', function (event) {
    if (window.pctCartEditMode && event.target && event.target.id === 'firebase-file-input') {
      window.pctCartEditPhotosChanged = true;
    }
  }, true);

  async function loadPctCartBookForView() {
    var ctx = readCtx();
    var bridge = window.pctCartViewBridge;
    shell('view');
    if (!ctx || ctx.action !== 'view' || !ctx.bookId || !ctx.storageFolder || !ctx.viewToken) {
      bridge.showStatus('Session expired', 'Please reopen the book preview from your cart.', true);
      return;
    }
    bridge.showStatus('Loading your book preview', 'Opening the saved book from your cart.', false);
    bridge.applyMetadata(ctx);
    setHiddenFromContext(ctx);
    var memory = await fetchBlueprint(ctx);
    bridge.renderViewMemory ? bridge.renderViewMemory(memory) : bridge.renderMemory(memory);
  }

  async function loadPctCartBookForEdit() {
    var ctx = readCtx();
    var bridge = window.pctCartViewBridge;
    shell('edit');
    if (!ctx || ctx.action !== 'edit' || !ctx.bookId || !ctx.storageFolder || !ctx.viewToken || !ctx.actionToken) {
      bridge.showStatus('Session expired', 'This edit session expired. Please reopen the book from your cart.', true);
      return;
    }
    bridge.showStatus('Loading your editable book', 'Opening the saved book from your cart.', false);
    setCartEditLoading(true, 'Opening your editable design.');
    installBuilderFallbackHooks();
    installEditUploadStatusHook();
    installEditDeletionHook();
    await api('validate-cart-action', { action: 'edit', token: ctx.actionToken });
    bridge.applyMetadata(ctx);
    setHiddenFromContext(ctx);
    var memory = await fetchBlueprint(ctx);
    var manifest = await fetchManifest(ctx);
    hydrateBuilderForCartEdit(ctx, memory, manifest);
    setCartEditLoading(false);
  }

  async function loadPctCartBookFromCart() {
    if (!window.pctCartViewMode && !window.pctCartEditMode) return;
    var bridge = window.pctCartViewBridge;
    if (!bridge) return;
    try {
      if (window.pctCartEditMode) await loadPctCartBookForEdit();
      else await loadPctCartBookForView();
    } catch (err) {
      if (window.pctCartEditMode) setCartEditLoading(false);
      console.error('Cart book load failed:', err);
      bridge.showStatus(window.pctCartEditMode ? 'Edit unavailable' : 'Preview unavailable', window.pctCartEditMode ? 'This saved item cannot be edited. You can still checkout or rebuild it from the product page.' : 'We could not load this book preview. Please return to cart or contact support.', true);
    }
  }

  window.pctSubmitCartEdit = async function (form) {
    var ctx = window.pctActiveCartEditContext;
    if (!ctx || !ctx.actionToken) {
      alert('This edit session expired. Please reopen the book from your cart.');
      return;
    }
    var snapshot = currentSnapshot(form);
    if (isIntentionalEditionGap(snapshot.photoCount)) {
      alert('You have 101 or 201 photos. Please remove one photo or upload one more before saving.');
      return;
    }
    if (window.pctCartEditPhotosChanged || window.isAutoPreparingDesign || window.pctCartEditRegenerating || !window.designConfirmed) {
      alert('Your preview is still preparing. Please wait until it finishes before saving.');
      return;
    }
    if (!(await pctShowCartEditReview(ctx, snapshot))) return;
    if (window.pctSetSavingUiLock) {
      window.pctSetSavingUiLock(true, {
        reason: 'cart-edit-save',
        title: 'Saving changes',
        message: 'Updating your cart with the latest book design.'
      });
    }

    var btn = document.getElementById('btn-add-cart');
    var text = document.getElementById('checkout-btn-text');
    var originalText = text ? text.innerHTML : '';
    if (btn) btn.disabled = true;
    if (text) text.innerHTML = '<div class="spinner" style="width:16px;height:16px;border-width:2px;display:inline-block;vertical-align:middle;margin-right:8px;"></div> Saving...';
    try {
      var memory = JSON.parse(JSON.stringify(window.spreadMemory || window.confirmedSpreadMemory || []));
      patchBlueprintPhotoRefs(memory);
      var manifest = window.pctBuildPhotoManifest ? window.pctBuildPhotoManifest() : { version: 1, photos: [] };
      var printBlueprint = window.PictoirelPrintBlueprint ? window.PictoirelPrintBlueprint.buildPrintBlueprint({
        bookId: ctx.bookId,
        storageFolder: ctx.storageFolder,
        layoutBlueprintPath: ctx.blueprintPath,
        photoManifestPath: ctx.photoManifestPath,
        spreadMemory: memory,
        photoManifest: manifest
      }) : null;
      var save = await api('save-blueprint', Object.assign({}, lineFields(ctx), {
        token: ctx.actionToken,
        line_signature: ctx.lineSignature,
        view_token: ctx.viewToken,
        next_variant_id: snapshot.variantId,
        save_attempt_id: ctx.pendingSaveAttemptId || (ctx.pendingSaveAttemptId = makeSaveAttemptId()),
        blueprint: memory,
        manifest: manifest,
        print_blueprint: printBlueprint
      }));

      var cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
      var line = findCurrentLine(cart, ctx);
      if (!line) throw new Error('Your cart changed. Please reopen Edit from the cart.');
      var currentProps = Object.assign({}, line.properties || {});
      if (String(currentProps['_Blueprint Version'] || ctx.blueprintVersion) !== String(ctx.blueprintVersion)) {
        throw new Error('This book was updated in another session. Reopen it from the cart.');
      }
      var formProps = readFormProperties(form);
      var printFields = {
        '_Print Blueprint Path': save.print_blueprint_path || (ctx.storageFolder + '/Print_Blueprint.json'),
        '_Print Blueprint Version': save.print_blueprint_version || '1'
      };
      var mergedProps = Object.assign(currentProps, formProps, {
        '_Blueprint Version': save.blueprint_version,
        '_Blueprint Path': save.blueprint_path,
        '_Photo Manifest Path': save.photo_manifest_path,
        '_Photo Manifest URL': save.photo_manifest_path,
        '_Line Signature': save.line_signature
      }, printFields);
      var sameVariant = String(line.variant_id || '') === String(snapshot.variantId || '');
      if (sameVariant) {
        var changed = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: mergedProps })
        });
        if (!changed.ok) throw new Error(await changed.text());
      } else {
        var freshIdentity = await prepareFreshCartLineIdentity(ctx, snapshot.variantId, save);
        var freshProps = Object.assign({}, currentProps, formProps, {
          '_Book ID': freshIdentity.bookId,
          '_Storage Folder': freshIdentity.storageFolder,
          '_Builder Handle': freshIdentity.builderHandle,
          '_Line Fingerprint': freshIdentity.lineFingerprint,
          '_Blueprint Version': save.blueprint_version,
          '_Blueprint Path': save.blueprint_path,
          '_Photo Manifest Path': save.photo_manifest_path,
          '_Photo Manifest URL': save.photo_manifest_path,
          '_Line Signature': freshIdentity.lineSignature,
          '_Line Created At': freshIdentity.createdAt
        }, printFields);
        await replaceCartLineVariant(ctx, line, snapshot.variantId, line.quantity, freshProps);
      }
      ctx.pendingSaveAttemptId = '';
      if (window.pctSetSavingUiLock) window.pctSetSavingUiLock(false, { reason: 'cart-edit-save' });
      await showCartEditSuccessModal();
      window.location.href = '/cart';
    } catch (err) {
      console.error('Cart edit save failed:', err);
      if (window.pctSetSavingUiLock) window.pctSetSavingUiLock(false, { reason: 'cart-edit-save' });
      alert(err.message || 'Your design was prepared, but we could not update the cart. Please try Save Changes again.');
      if (btn) btn.disabled = false;
      if (text) text.innerHTML = originalText || 'Save Changes';
    }
  };

  window.loadPctCartBookFromCart = loadPctCartBookFromCart;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPctCartBookFromCart);
  } else {
    loadPctCartBookFromCart();
  }
})();
